<custom-table
    tableName="selectTransactionTable"
    [displayedColumns]="displayedColumns()"
    [dataSource]="dataSource()"
    [enableRowSelection]="true"
    (onRowsSelected)="onRowSelected($event)"
    [enablePagination]="true"></custom-table>
